import React from 'react';

import {AlertActions, AlertModal} from 'presentation/components';
import {useMediaQueries} from 'presentation/pages/private/hooks';
import {translations} from 'presentation/translations-new';
import {FlowEnum} from '../../constants';
import {BookingNotFoundDialogProps, BookingNotFoundVariantEnum} from './types';

const {state, city, locality, consultNetworkProviderHealth, consultNetworkProviderOdonto} =
	translations['pt-br'].privateFlow.profile.locationSelection;
const {chatOnline, specialtyFlow, unitsFlow, districtFlow} =
	translations['pt-br'].privateFlow.bookingFlow;

export function BookingNotFoundDialog({
	variant,
	handleCallChatRoom,
	handleGuideNav,
	open,
	setOpen,
	flowType,
	firstActionDataTagId,
	secondActionDataTagId,
	headerModalDataTagId,
	closeModalDataTagId,
}: BookingNotFoundDialogProps) {
	const {isMobile} = useMediaQueries();

	const isExam = flowType === FlowEnum.EXAM;
	const isOdonto = flowType === FlowEnum.ODONTO;
	const isDistrictOdonto = isOdonto && variant === BookingNotFoundVariantEnum.DISTRICT;

	const getDescriptions = () => {
		if (!isOdonto) {
			return {
				guideButtonLabel: consultNetworkProviderHealth,
				cityDescription: city.notFoundModal.descriptionNetworkProvider,
				stateDescription: state.notFoundModal.descriptionNetworkProvider,
				specialtyDescription: specialtyFlow.notFoundModal.descriptionNetworkProvider,
				unitsFlowDescription: unitsFlow.notFoundModal.descriptionNetworkProvider,
				localityDescription: locality.notFoundModal.descriptionNetworkProvider,
				districtDescription: districtFlow.notFoundModal.descriptionAllHealth,
			};
		}
		return {
			guideButtonLabel: consultNetworkProviderOdonto,
			cityDescription: city.notFoundModal.descriptionNetworkProviderDental,
			stateDescription: state.notFoundModal.descriptionNetworkProviderDental,
			specialtyDescription: specialtyFlow.notFoundModal.descriptionNetworkProviderDental,
			unitsFlowDescription: unitsFlow.notFoundModal.descriptionNetworkProviderDental,
			localityDescription: locality.notFoundModal.descriptionNetworkProvider,
			districtDescription: districtFlow.notFoundModal.descriptionAll,
		};
	};

	const descriptions = getDescriptions();

	const NOT_FOUND_CONTENT = (() => ({
		[BookingNotFoundVariantEnum.CITY]: {
			headerTitle: city.notFoundModal.headerTitle,
			title: city.notFoundModal.title,
			description: descriptions.cityDescription,
			modalActionButton: descriptions.guideButtonLabel,
		},
		[BookingNotFoundVariantEnum.UF]: {
			headerTitle: state.notFoundModal.headerTitle,
			title: state.notFoundModal.title,
			description: descriptions.stateDescription,
			modalActionButton: descriptions.guideButtonLabel,
		},
		[BookingNotFoundVariantEnum.SPECIALTY]: {
			headerTitle: isExam
				? specialtyFlow.notFoundModal.examHeaderTitle
				: specialtyFlow.notFoundModal.headerTitle,
			title: isExam
				? specialtyFlow.notFoundModal.examTitle
				: specialtyFlow.notFoundModal.title,
			description: descriptions.specialtyDescription,
			modalActionButton: descriptions.guideButtonLabel,
		},
		[BookingNotFoundVariantEnum.DISTRICT]: {
			headerTitle: districtFlow.notFoundModal.headerTitle,
			title: districtFlow.notFoundModal.title,
			description: descriptions.districtDescription,
			modalActionButton: isOdonto
				? consultNetworkProviderOdonto
				: consultNetworkProviderHealth,
		},
		[BookingNotFoundVariantEnum.UNIT]: {
			headerTitle: unitsFlow.notFoundModal.headerTitle,
			title: unitsFlow.notFoundModal.title,
			description: descriptions.unitsFlowDescription,
			modalActionButton: descriptions.guideButtonLabel,
		},
		[BookingNotFoundVariantEnum.LOCALITY]: {
			headerTitle: locality.notFoundModal.headerTitle,
			title: locality.notFoundModal.title,
			description: descriptions.localityDescription,
			modalActionButton: consultNetworkProviderHealth,
		},
	}))();

	return (
		<AlertModal
			headerDataTagId={headerModalDataTagId}
			closeBtnDataTagId={closeModalDataTagId}
			slotProps={{
				paper: {
					style: {
						maxWidth: 420,
						margin: isMobile ? 16 : 'auto',
						flex: isMobile ? 1 : 'initial',
					},
				},
			}}
			footerContent={
				<AlertActions
					primaryAction={() => handleGuideNav(flowType)}
					dataTagId={firstActionDataTagId}
					secondaryBtnDataTagId={secondActionDataTagId}
					secondaryAction={isDistrictOdonto ? undefined : () => handleCallChatRoom()}
					secondaryText={isDistrictOdonto ? undefined : chatOnline}
					primaryText={NOT_FOUND_CONTENT[variant].modalActionButton}
					flexDirection="column-reverse"
				/>
			}
			description={NOT_FOUND_CONTENT[variant].description}
			headerTitle={NOT_FOUND_CONTENT[variant].headerTitle}
			onClose={() => setOpen(false)}
			title={NOT_FOUND_CONTENT[variant].title}
			open={open}
			variant="primary"
		/>
	);
}
